import axios from './http';
import { CancelTokenSource } from 'axios';
import { MedIndexDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/medindex-config`;

export const getMedIndex = (source: CancelTokenSource) : Promise<MedIndexDto>=> {

  return axios
      .get(`${apiUri}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const editMedIndex = (
    medIndexDto: Partial<MedIndexDto>,
    source: CancelTokenSource)
    : Promise<MedIndexDto> => {

  return axios
      .put(`${apiUri}`, medIndexDto, {cancelToken: source.token})
      .then(response => response.data);
};
